import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { WhatsAppFab } from '@/components/WhatsAppFab';
import { Seo } from '@/components/Seo';

export const Layout = () => {
  const location = useLocation();
  const { i18n } = useTranslation();
  const seg = location.pathname.split('/').filter(Boolean)[0];
  const lang = seg === 'en' ? 'en' : 'it';

  useEffect(() => {
    if (i18n.language !== lang) i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
  }, [lang, i18n]);

  return (
    <div className="min-h-screen flex flex-col bg-beige overflow-x-hidden">
      <Seo />
      <Header lang={lang} />
      <main className="flex-1">
        <Outlet context={{ lang }} />
      </main>
      <Footer lang={lang} />
      <WhatsAppFab />
    </div>
  );
};
